import {useCallback, useEffect, useRef, useState} from "react";

import {closeFlow, RegistrationFlowStep} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {closeAuthDrawer, openPhoneVerificationStep} from "../state/semantic_search_auth_slice";

/**
 * After login/registration: refreshes auth and profile, then on the next render reads
 * {@link useShouldHidePrices} (verified phone, etc.) and either closes the overlay or proceeds to the PIN step.
 */
export const useSemanticSearchPostAuthNavigation = () => {
    const dispatch = useAppDispatch();
    const registrationFlow = useAppSelector((state) => state.registrationFlow);
    const {refetch} = useGetUserProfileQuery();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();

    const [postAuthCheckId, setPostAuthCheckId] = useState(0);
    const processedCheckIdRef = useRef(0);

    const completeAuthFlow = useCallback(async () => {
        try {
            await dispatch(getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true})).unwrap();
            await refetch();
            setPostAuthCheckId((id) => id + 1);
        } catch {
            dispatch(closeAuthDrawer());
        }
    }, [dispatch, refetch]);

    useEffect(() => {
        if (postAuthCheckId === 0 || postAuthCheckId === processedCheckIdRef.current) {
            return;
        }

        processedCheckIdRef.current = postAuthCheckId;

        if (!isUserLoggedIn) {
            dispatch(closeAuthDrawer());
            return;
        }

        if (hasCompleteProfile && hasPhoneVerified) {
            dispatch(closeAuthDrawer());
            return;
        }

        if (!hasPhoneVerified) {
            if (
                registrationFlow.isActive &&
                (registrationFlow.currentStep === RegistrationFlowStep.PHONE_VERIFICATION ||
                    registrationFlow.currentStep === RegistrationFlowStep.PHONE_COMPLETION)
            ) {
                dispatch(closeFlow());
            }
            dispatch(openPhoneVerificationStep());
            return;
        }

        dispatch(closeAuthDrawer());
    }, [postAuthCheckId, hasCompleteProfile, hasPhoneVerified, isUserLoggedIn, registrationFlow.isActive, registrationFlow.currentStep, dispatch]);

    return {completeAuthFlow};
};
import {useCallback, useEffect, useRef, useState} from "react";

import {closeFlow, RegistrationFlowStep} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {closeAuthDrawer, openPhoneVerificationStep} from "../state/semantic_search_auth_slice";

/**
 * After login/registration: refreshes auth and profile, then on the next render reads
 * {@link useShouldHidePrices} (verified phone, etc.) and either closes the overlay or proceeds to the PIN step.
 */
export const useSemanticSearchPostAuthNavigation = () => {
    const dispatch = useAppDispatch();
    const registrationFlow = useAppSelector((state) => state.registrationFlow);
    const {refetch} = useGetUserProfileQuery();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();

    const [postAuthCheckId, setPostAuthCheckId] = useState(0);
    const processedCheckIdRef = useRef(0);

    const completeAuthFlow = useCallback(async () => {
        try {
            await dispatch(getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true})).unwrap();
            await refetch();
            setPostAuthCheckId((id) => id + 1);
        } catch {
            dispatch(closeAuthDrawer());
        }
    }, [dispatch, refetch]);

    useEffect(() => {
        if (postAuthCheckId === 0 || postAuthCheckId === processedCheckIdRef.current) {
            return;
        }

        processedCheckIdRef.current = postAuthCheckId;

        if (!isUserLoggedIn) {
            dispatch(closeAuthDrawer());
            return;
        }

        if (hasCompleteProfile && hasPhoneVerified) {
            dispatch(closeAuthDrawer());
            return;
        }

        if (!hasPhoneVerified) {
            if (
                registrationFlow.isActive &&
                (registrationFlow.currentStep === RegistrationFlowStep.PHONE_VERIFICATION ||
                    registrationFlow.currentStep === RegistrationFlowStep.PHONE_COMPLETION)
            ) {
                dispatch(closeFlow());
            }
            dispatch(openPhoneVerificationStep());
            return;
        }

        dispatch(closeAuthDrawer());
    }, [postAuthCheckId, hasCompleteProfile, hasPhoneVerified, isUserLoggedIn, registrationFlow.isActive, registrationFlow.currentStep, dispatch]);

    return {completeAuthFlow};
};
